import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import CropperScaffold from '../common/forms/CropperScaffold';
import ReduxFormField from '../common/forms/ReduxFormsField';
import ReduxFormsImageCropper from '../common/forms/ReduxFormsImageCropper';
import Loading from '../common/components/Loading';
import cloneDeep from 'lodash/cloneDeep';

const validate = values => {
  let errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = ['Name is required'];
  } else if (values.name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }
  if (!values.image) {
    errors.image = ['Image is required'];
  }

  return errors;
};

class AddEditBadgeForm extends Component {
  static propTypes = {
    ...formPropTypes,
    badge: PropTypes.object,
    clearOrigImage: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    removeImage: PropTypes.func.isRequired,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);

    submitValues.name = submitValues.name.trim();

    return this.props.onSubmit(submitValues);
  };

  render() {
    const { badge, clearOrigImage, handleSubmit, onCancel, removeImage, submitting } = this.props;

    if (submitting) {
      return (
        <div className="modal__content">
          <Loading />
        </div>
      );
    }
    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div className="modal__content">
          <h3>{`${badge ? 'Edit' : 'Add'} Badge`}</h3>
          <Field name="name" component={ReduxFormField} label="Badge Name" required={true}>
            <input type="text" />
          </Field>
          {badge && badge.get('image_id') && !clearOrigImage ? (
            <CropperScaffold label="Course Image" required>
              <div className="original-image">
                <img alt="course logo" src={badge.getIn(['image', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeImage}>
                  Remove Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="image" component={ReduxFormsImageCropper} label="Badge Image" />
          )}
        </div>
        <div className="modal__actions">
          <div className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
            Cancel
          </div>
          <button type="submit" className="button" disabled={submitting}>
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'addEditBadge',
  validate,
})(AddEditBadgeForm);



// WEBPACK FOOTER //
// ./src/badges/AddEditBadgeForm.js